<template>
  <div class="auth">
    <p class="title_">本人同意对上海南燕信息技术有限公司（上海南燕）授权如下：</p>
    <p class="title_ mB0_">1、本人同意授权上海南燕根据本人提供的身份证件号码，查询本人对保险从业人员相关执业登记情况。本人承诺，本人提供的身份证号码真实，不存在借用、冒用等情况。如因本人违反该承诺而产生的法律责任，由本人承担。</p>
    <p class="title_">2、本人的保险从业人员相关执业登记情况如发生变更登记、注销登记等情形的，应及时通知上海南燕。如因本人未及时通知而产生的法律责任，由本人承担。</p>
    <div>
      <cube-button class="okbtn_" @click="agree">我已知晓并同意</cube-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    document.title = '资质认证'
    return {
      authName: '',
      name: '',
      idNumber: '',
      idType: '',
      idTypeText: '',
      license,
      company,
    }
  },
  created() {
    let { authName,name,idNumber,idType,idTypeText,license,company }  = this.$route.query
    this.authName = authName
    this.idNumber = idNumber
    this.name = name
    this.idType = idType
    this.idTypeText = idTypeText
    this.license = license
    this.company = company
  },
  methods: {
    agree() {
      this.$router.push({
        path: '/bs/authentication',
        query: {
          checked: true,
          realName: this.authName,
          name: this.name,
          idNumber: this.idNumber,
          idType: this.idType,
          idTypeText: this.idTypeText,
          license: this.license,
          company: this.company
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.auth {
  width: 100%;
  padding: 30px 20px 0;
  .title_ {
    color: #999999;
    font-size: 13px;
    line-height: 19px;
    text-align: left;
    margin-bottom: 25px;
  }
  .mB0_ {
    margin-bottom: 0;
  }
  .okbtn_ {
    border-radius: 14px;
    background: linear-gradient(45deg, #FF7C6C 0%, #FFA297 100%);
    
  }
}
</style>
